import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';

function LanguageWarning() {
    const { t, i18n } = useTranslation();
    const [dismissed, setDismissed] = useState(false);

    // Reset dismissed state when language changes
    useEffect(() => {
        setDismissed(false);
    }, [i18n.resolvedLanguage]);

    // Check if the current language is not English
    const isNotEnglish = i18n.resolvedLanguage && !i18n.resolvedLanguage.startsWith('en');

    return (
        <AnimatePresence>
            {isNotEnglish && !dismissed && (
                <motion.div 
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    className="w-full bg-amber-50 border-b border-amber-200"
                >
                    <div className="max-w-7xl mx-auto px-4 py-3 flex items-start sm:items-center justify-between gap-3 text-amber-800">
                        <div className="flex items-start sm:items-center gap-3">
                            <i className="fi fi-sr-info mt-1 sm:mt-0 text-amber-500"></i>
                            <p className="text-sm font-medium leading-tight">
                                {t('warning.message')}
                            </p>
                        </div>
                        <button onClick={() => setDismissed(true)} className="p-1 hover:bg-amber-100 rounded-full transition-colors shrink-0 text-amber-600">
                            <i className="fi fi-br-cross text-xs flex items-center justify-center"></i>
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default LanguageWarning;
